const interpolate = (num1, num2, amount) => num1 + (num2 - num1) * amount;

export default interpolate;
